import React from 'react';
import { PrivacyPolicyContainer } from '../PrivacyPolicy/PrivacyStyles.styles';

const Header = () => {
  return (
    <PrivacyPolicyContainer>
      <p>Last Updated: September 24, 2026</p>

      <p>
        Welcome to Yoda Safety Services. These Terms & Conditions govern your
        access to and use of the Yoda Safety Services website, online training
        platform, courses, company accounts, digital safety tools,
        subscriptions, documentation, and other products, services, features,
        and resources made available through our website or platform.
      </p>

      <p>
        By accessing or using our website, platform, or services, you agree to
        be bound by these Terms & Conditions and any additional terms that may
        apply to specific services or purchases. If you do not agree to these
        Terms & Conditions, you should not access or use the applicable
        services.
      </p>

      <p>
        Certain features or services may be subject to additional requirements,
        policies, agreements, or terms. Where applicable, those additional terms
        form part of your agreement with Yoda Safety Services in relation to the
        applicable service.
      </p>
    </PrivacyPolicyContainer>
  );
};

export default Header;
